define("calendar/components/calendar/settings/notes", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <hr class="u--m__b__0" />
  <div class="u--row">
    <div class="u--col__4 u--m__t__md">
      <h5 class="u--text--md u--m__0" data-test-id="calendar-settings-notes-title">
        {{t "calendar.settings.calendar_notes_title"}}
      </h5>
    </div>
    <div class="u--col__8 u--m__t__md">
      {{#if this.canCalendarNotes}}
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "calendar.settings.calendar_notes_label"}}
          @propertyToggled={{@showCalendarNotes}}
          @toggleAction={{@toggleCalendarNotes}}
          class="u--p__0 u--m__b"
          data-qa-id="calendar-notes-toggle"
          data-test-notes="settings-checkbox"
        />
      {{else}}
        <h5 class="u--text--md u--m__t__0">
          {{#if this.canTrialPlan}}
            {{t "calendar_notes.try"}}
          {{else}}
            {{t "calendar_notes.upgrade"}}
          {{/if}}
        </h5>
  
        <p class="u--text--light">
          {{t "calendar_notes.notes_settings_sub_text"}}
        </p>
  
        <Shared::Button::Upgrade
          @feature="calendarNotes"
          @location="calendar settings note"
          @seamlessCheckoutSuccessCallback={{@closeSettingsModal}}
          @text={{this.upgradeButtonText}}
          @variant="proceed"
        />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "h78MedhH",
    "block": "[[[10,\"hr\"],[14,0,\"u--m__b__0\"],[12],[13],[1,\"\\n\"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--m__t__md\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__0\"],[14,\"data-test-id\",\"calendar-settings-notes-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"calendar.settings.calendar_notes_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__8 u--m__t__md\"],[12],[1,\"\\n\"],[41,[30,0,[\"canCalendarNotes\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"u--p__0 u--m__b\"],[24,\"data-qa-id\",\"calendar-notes-toggle\"],[24,\"data-test-notes\",\"settings-checkbox\"]],[[\"@labelText\",\"@propertyToggled\",\"@toggleAction\"],[[28,[37,0],[\"calendar.settings.calendar_notes_label\"],null],[30,1],[30,2]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0\"],[12],[1,\"\\n\"],[41,[30,0,[\"canTrialPlan\"]],[[[1,\"          \"],[1,[28,[35,0],[\"calendar_notes.try\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,0],[\"calendar_notes.upgrade\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\\n      \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"calendar_notes.notes_settings_sub_text\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,3],null,[[\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@text\",\"@variant\"],[\"calendarNotes\",\"calendar settings note\",[30,3],[30,0,[\"upgradeButtonText\"]],\"proceed\"]],null],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@showCalendarNotes\",\"@toggleCalendarNotes\",\"@closeSettingsModal\"],false,[\"t\",\"if\",\"shared/ui/checkbox-switch\",\"shared/button/upgrade\"]]",
    "moduleName": "calendar/components/calendar/settings/notes.hbs",
    "isStrictMode": false
  });
  let NotesComponent = _exports.default = (_class = class NotesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }
    get canCalendarNotes() {
      return Boolean(this.auth.currentAccount.canCalendarNotes);
    }
    get canTrialPlan() {
      return Boolean(this.auth.currentAccount.canTrialPlan);
    }
    get upgradeButtonText() {
      if (this.subscriptions.isEligibleForTrial) {
        return this.intl.t('authorization.sign_up_trial.button_yes');
      } else if (this.subscriptions.hasActiveTrial && !this.canCalendarNotes) {
        return this.intl.t('plans.upgrade.upgrade_trial');
      }
      return this.intl.t('shared_phrases.upgrade_plan');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NotesComponent);
});